import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultOrdersDispatchData, updateOrdersDispath, getOrdersDispathById, updateEway } from '@/api/orders-dispatches';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import { Action } from 'vuex-module-decorators';
import router from '@/router';
import { AdminModule } from '@/store/modules/admin';
import { getDealersTransporters } from '@/api/dealers-transporters';
import { getQuery } from '@/utils';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultOrdersDispatchData);
    this.loading = false;
    this.rules = {
      transporterId: {
        required: true,
        trigger: 'blur',
        message: 'This field is required'
      }
    };
    this.loggedInAdmin = null;
    this.ordersDispatchId = 0;
    this.transporterListLoading = false;
    this.transporterList = [];
    this.transporterId = null;
    this.dealerId = 0;
    this.ewayUpdateFromData = {};
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.ordersDispatchId = +id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultOrdersDispatchData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getOrdersDispathById(id);
      this.formData = data;
      this.dealerId = data.dealerId;
      // this.ewayUpdateFromData.transporterId = data.dealersTransporter.transporter.id;
      if (this.dealerId) {
        await this.fetchTransporterList(this.dealerId);
      }
      // Just for test
      const title = 'Update E-way - #' + this.formData.id;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title}`;
  }
  submitForm() {
    this.$refs.ewayUpdateFromData.validate(valid => {
      if (valid) {
        this.updateEWay();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      // format date
      this.formData.lrDate = this.$moment(this.formData.lrDate).format('YYYY-MM-DD');
      let response = {
        status: 'info',
        message: 'Try again!'
      };
      if (this.isEdit) {
        const dataToUpdate = {
          lrNumber: this.formData.lrNumber,
          lrDate: this.formData.lrDate
        };
        response = await updateOrdersDispath(this.formData.id, dataToUpdate);
      }
      this.loading = false;
      this.$notify({
        title: response.status,
        message: response.message,
        type: response.status,
        duration: 2000
      });
      router.push('/orders-dispatches/list');
    } catch (err) {
      this.loading = false;
    }
  }
  async fetchTransporterList(dealerId = 0) {
    // fetch dealers transporters
    this.transporterList = await getDealersTransporters(getQuery({
      enabled: true,
      dealerId,
      sort: 'isPrimary,ASC',
      filter: {
        enabled: '$eq',
        dealerId: '$eq'
      }
    }));
  }
  async updateEWay() {
    // update E-way
    try {
      this.loading = true;
      this.$confirm('Do you want to update E-way?', 'Update E-way', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--success',
        cancelButtonText: 'No',
        cancelButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(async () => {
        const updateEWayRequest = {
          id: this.ordersDispatchId,
          transporterId: this.ewayUpdateFromData.transporterId
        };
        const updateEWayResponse = await updateEway(updateEWayRequest);
        if (updateEWayResponse && updateEWayResponse.status === 'success') {
          this.$message({
            message: 'E-way updated successfully. Kindly upload the updated the E-way PDF.',
            type: 'success'
          });
          router.push('/orders-dispatches/upload-eway-pdf/' + this.ordersDispatchId);
        } else {
          this.$message({
            message: 'Failed to update E-way',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'OrdersDispatchDetail',
  components: {}
})], default_1);
export default default_1;